import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import type { IconProps } from '@avodah-inc/types';
import { cn } from '@avodah-inc/ui/utils';

const personFilledVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
      primary: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type PersonFilledProps = React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof personFilledVariants> &
  IconProps;

export const PersonFilled = React.forwardRef<SVGSVGElement, PersonFilledProps>(
  (
    {
      className,
      variant,
      viewBox,
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        className={cn(
          personFilledVariants({
            variant,
            className,
          }),
        )}
        fill={fill}
        height={height}
        ref={ref}
        viewBox={viewBox}
        width={width}
        {...props}
      >
        <path d="M12.0001 2.3999C10.7271 2.3999 9.50616 2.90562 8.60598 3.80579C7.70581 4.70596 7.2001 5.92686 7.2001 7.1999C7.2001 8.47294 7.70581 9.69384 8.60598 10.594C9.50616 11.4942 10.7271 11.9999 12.0001 11.9999C13.2731 11.9999 14.494 11.4942 15.3942 10.594C16.2944 9.69384 16.8001 8.47294 16.8001 7.1999C16.8001 5.92686 16.2944 4.70596 15.3942 3.80579C14.494 2.90562 13.2731 2.3999 12.0001 2.3999ZM6.0109 13.1999C5.69486 13.1986 5.38168 13.2598 5.08933 13.3798C4.79697 13.4998 4.53118 13.6764 4.30721 13.8994C4.08323 14.1223 3.90548 14.3873 3.78414 14.6791C3.6628 14.971 3.60025 15.2839 3.6001 15.5999C3.6001 17.6291 4.5997 19.1591 6.1621 20.1563C7.7005 21.1367 9.7741 21.5999 12.0001 21.5999C14.2261 21.5999 16.2997 21.1367 17.8381 20.1563C19.4005 19.1603 20.4001 17.6279 20.4001 15.5999C20.4001 14.9634 20.1472 14.3529 19.6972 13.9028C19.2471 13.4528 18.6366 13.1999 18.0001 13.1999H6.0109Z" />
      </svg>
    );
  },
);

PersonFilled.displayName = 'PersonFilled';
